import Api from "shared/service/api/api";

//actions
export const LOAD_CALLCENTER_CLIENTS = "loadCallcenterClients";

//mutations
export const SET_CALLCENTER_CLIENTS = "setClients";

const state = {
  clients: {
    list: [],
    page: 1,
    page_count: 1,
  },
};

const actions = {
  [LOAD_CALLCENTER_CLIENTS]({ commit }, { page, client_id = null }) {
    Api.callcenter.client
      .all(page, client_id)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_CALLCENTER_CLIENTS, response.data);
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_CALLCENTER_CLIENTS](state, { list, page, page_count }) {
    state.clients.list = list;
    state.clients.page = page;
    state.clients.page_count = page_count;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
